import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFinanceSummaryQuery, } from "generated/generated-models";
import { Loading } from "../lib/components/Loading";
import { clientConfigFn } from "clientConfig";
import { FinanceSummaryView } from "./FinanceSummaryView";
import { useEffect } from "react";
const FinanceSummaryComponent = (props) => {
    const { data, loading, error } = useFinanceSummaryQuery();
    const financeSummary = data?.financeSummary;
    useEffect(() => {
        if (financeSummary?.Instruments != null &&
            financeSummary.Instruments.length > 0 &&
            !props.account) {
            props.handleOnSelectedAccount(financeSummary.Instruments[0].Accounts[0]);
        }
    }, [financeSummary?.Instruments, props]);
    if (loading) {
        return _jsx(Loading, {});
    }
    if (error) {
        return _jsxs("div", { children: ["Error!: ", error.message] });
    }
    if (!data) {
        return (_jsx(FinanceSummaryView, { handleOnSelectedAccount: props.handleOnSelectedAccount }));
    }
    const { myFinancesTitle, showUserInWelcomeMessage } = clientConfigFn();
    return (_jsx(FinanceSummaryView, { financeSummary: financeSummary, myFinancesTitle: myFinancesTitle, showUserInWelcomeMessage: showUserInWelcomeMessage, handleOnSelectedAccount: props.handleOnSelectedAccount }));
};
export { FinanceSummaryComponent };
